export default {"src":"/_next/static/media/ABNB.5c3aa2e0.svg","height":18,"width":18};